import { flowNodeSubjectName, type FlowNodeRow } from "@/types/flow"

type StarterNode = Pick<FlowNodeRow, "kind" | "chain_input" | "media_url" | "title" | "entity_name" | "shot_label">

type ChainInputNode = Pick<FlowNodeRow, "kind" | "chain_slots">

/** Начальная нода без файла: её надо сгенерировать или отметить инпутом. */
export function chainStarterInputWarning(node: StarterNode, starter: boolean, pending: boolean): boolean {
  if (!starter || pending || node.chain_input) return false
  if (node.kind === "audio" || node.kind === "chain") return false
  return !node.media_url
}

/** Цепочка со слотами не бывает входом: слоты закрывают отдельные входные ноды. */
export function chainNodeCanBeInput(node: ChainInputNode): boolean {
  if (node.kind !== "chain") return true
  return (node.chain_slots?.length ?? 0) === 0
}

/** Стартовая цепочка со слотами: на карточке подсказка вместо кнопки «Сделать входом». */
export function chainNestedInputsHint(node: ChainInputNode, starter: boolean): boolean {
  return starter && !chainNodeCanBeInput(node)
}

/** Своё название, иначе подпись сущности или шота, иначе переданный fallback. */
export function chainStarterName(node: StarterNode, untitled: string): string {
  const title = node.title?.trim()
  if (title) return title
  return flowNodeSubjectName(node) ?? untitled
}
